import styled from 'styled-components'

export const SidebarGroupBtn = styled.div`
    display: flex;
`